<template>
	<div>
		<template v-for="(content, i) in componentItem.content">
			<div :key="i">
				<div>
					<div v-if="i === 'background-image'">
						<BackgroundImage :backgroundImage="componentItem.content[i]" :forTemplate="componentItem.template"/>
					</div>
					<div v-else-if="typeof content !== 'object'" class="form-group">
						<label>{{ i }}</label>
						<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]" >
					</div>
				</div>
			</div>
		</template>
		<BackgroundAudio :componentItemContent="componentItem.content" />
		<BackgroundVideo :componentItemContent="componentItem.content" />

	</div>
</template>

<script>
	import BackgroundImage from '../BackgroundImage';
	import BackgroundVideo from '../BackgroundVideo';
	import BackgroundAudio from '../BackgroundAudio';

	export default {

		components: {
			BackgroundImage,
			BackgroundVideo,
			BackgroundAudio
		},

		name: 'Hero',
		
		props: ['componentItem', 'index'],

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}

</style>